<template>
    <div>
        <a-card title="用户行为" >
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>

            <div style="margin-bottom:18px;">
                <div>
                    <envSelecter v-model="searchP.selectedEnv" style="display:inline-flex;"></envSelecter>
                    <sysSelecter v-model="searchP.sleectedSys" style="display:inline-flex;"></sysSelecter>
                    <timeSelecter ref="timeSelecterID" v-model="searchP.selectedTimeRange" style="margin-left:20px;"></timeSelecter>
                    <div class="ItemGroup">
                        <div class="searchItem">
                            <div class="searchLabel">sessionID：</div>
                            <a-input style="width:200px;" placeholder="用户访问周期的sessionid" v-model="searchP.session_id" />
                        </div>
                        <a-button type="primary" @click="handleSubmit">
                            查询
                        </a-button>
                    </div>

                    
                </div>
            </div>
            <a-row :gutter="[16,16]">
                <a-col :span='20'>
                    <timeline ref="userTimelineID"></timeline>
                </a-col>
            </a-row>
        </a-card>

    </div>
    
</template>


<script>

import timeSelecter from '../components/timeselecter'
import sysSelecter from '../components/sysSelecter'
import envSelecter from '../components/envSelecter'
import timeline from './timeline'
import moment from 'moment';
export default {
    data(){
        return {
            
            searchP:{
                dateFormat:"YYYY-MM-DD HH:mm",
                session_id:'',
                sleectedSys:'',
                selectedEnv:'',
                selectedTimeRange:'',
            }
        }
    },
    methods:{
        handleSubmit(){
            this.$refs.userTimelineID.getUserLogs(this.searchP);
        },
        
    },
    mounted(){
        const {query} =  this.$route;
        if(query.session_id){
            this.searchP.session_id = query.session_id
        }
        if(query.base_time){
            //链路上下24小时时间
            let timePoint = query.base_time;
            let sTime = new Date(timePoint).getTime() - 24 * 60 * 60000;
            let targetTime = new Date(timePoint).getTime();
            let nowTime = new Date().getTime();
            let eTime = targetTime + 24 * 60 * 60000;

            if(eTime > nowTime){
                eTime = nowTime
            }

            let t = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)]
            this.$refs.timeSelecterID.setTime(t);
            this.handleSubmit()
        }
        else{
            this.message.info('请填写sessionid')
        }
    },
    destroyed(){
       
    },
    components:{
        timeSelecter,
        sysSelecter,
        timeline,
        envSelecter
    }
};
</script>

<style lang="less" scoped>
    .searchLabel{
        width:80px;
        display: inline-block;
        color:rgba(0,0,0,.85);
    }
    .searchItem{
        margin-bottom: 20px;
    }

    .ItemGroup{
        width:100%;
        height:auto;
        display: inline-block;
        margin-top: 20px;
    }

    .ItemGroup .searchItem{
        float: left;
        margin-right:20px;
    }
</style>
